var render, staticRenderFns
import script from "./msBaseComponentDefault.vue?vue&type=script&lang=js"
export * from "./msBaseComponentDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bb5144",
  null
  
)

export default component.exports